import { createStore } from "redux";
import { casherReducer } from "../reducer/reducer";
import { composeWithDevTools } from 'redux-devtools-extension';
import { applyMiddleware } from "redux";
import thunk from "redux-thunk";
export const store = createStore(casherReducer, applyMiddleware(thunk))